import React from 'react';
import PropTypes from 'prop-types';
import {Utilities} from '@learningblocks/exp-constants';
import './style.scss';

const {SLIDE_NODE, checkIfNodeComplete} = Utilities;
const NODE_STATES = {
  EMPTY: 'EMPTY',
  CURRENT: 'CURRENT',
  COMPLETE: 'COMPLETE',
};

/**
 * GroupListing: Component is a Listing Component for
 * BoxGroup Component. It list all GroupNodes.
 */
export function GroupListing(props) {
  const setNodeState = (node) => {
    let nodeComplete = checkIfNodeComplete(node);
    let nodeState = NODE_STATES.EMPTY;
    if (node.current) nodeState = NODE_STATES.CURRENT;
    if (nodeComplete) nodeState = NODE_STATES.COMPLETE;
    return nodeState;
  };

  const renderGroupNode = (groupNode) => {
    switch (groupNode.nodeType) {
      case SLIDE_NODE.BOX_DRAG_DROP:
        return React.cloneElement(props.rectDragDropRow, {
          ...groupNode,
          key: groupNode.nodeId,
          nodeState: setNodeState(groupNode),
          nodeHolder: React.cloneElement(
            props.rectDragDropRow.props.nodeHolder,
            {
              current: groupNode.current,
            }
          ),
        });
      case SLIDE_NODE.JOINT_DRAG_DROP:
        return React.cloneElement(props.jointDragDropRow, {
          ...groupNode,
          key: groupNode.nodeId,
          nodeState: setNodeState(groupNode),
          nodeHolder: React.cloneElement(
            props.jointDragDropRow.props.nodeHolder,
            {
              current: groupNode.current,
            }
          ),
        });
      default:
        return null;
    }
  };
  const setStyle = () => ({
    borderColor: props.color,
  });

  return (
    <div className={`${props.wrapClass}__groupList`} style={setStyle()}>
      <p className={`${props.wrapClass}__groupList--label`}>{props.label}</p>
      {props.groupNodes.map(renderGroupNode)}
    </div>
  );
}

GroupListing.propTypes = {
  /**
   * List of groupNodes that needs to be rendered
   */
  groupNodes: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Booelean for specifying if current node.
       */
      current: PropTypes.bool,
      /**
       * List of components to be displayed in GroupRow
       */
      nodeComponents: PropTypes.array,
      /**
       * Object contains error messages for incorrect drops,
       * based on position of element
       */
      nodeFeedback: PropTypes.object,
      /**
       * Unique id for the Node
       */
      nodeId: PropTypes.number.isRequired,
      /**
       * The type of node.
       */
      nodeType: PropTypes.oneOf([
        SLIDE_NODE.JOINT_DRAG_DROP,
        SLIDE_NODE.BOX_DRAG_DROP,
      ]).isRequired,
    })
  ),
  /**
   * Label string the describe the actions in box
   */
  label: PropTypes.string.isRequired,
  /**
   * String to be set as prefix to className
   */
  wrapClass: PropTypes.string.isRequired,
  /**
   * Theme color of BoxGroup in hex
   */
  color: PropTypes.string,
  /**
   * DragDrop Row component for FullWidthCard nodes
   */
  rectDragDropRow: PropTypes.element.isRequired,
  /**
   * DragDropRow component for HexagonCard nodes
   */
  jointDragDropRow: PropTypes.element.isRequired,
};

GroupListing.defaultProps = {
  color: '#fff',
  groupNodes: [],
};
